module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-title-bd36ed831c582c65af6f1e05f1d828ed.svg";